<template>
  <div class="jackPotNew">
    <el-dialog width="1070px" :visible.sync="adVisible" :show-close="false">
      <div class="jkContent">
        <ul class="jkTabs">
          <li v-for="(item, index) in adList" :key="index" :class="{ 'active': index === currentIndex }"
            @click="changeTab(item, index)">
            <i></i>
            <span>{{ item.title }}</span>
          </li>
        </ul>
        <div class="jkHtml">
          <img @click="bannerTransgo(currentList)" :src="$config.imgHost + currentList.picture" />
        </div>
      </div>
      <div class="jkClose" @click="closePop"></div>
      <div class="notToday">
        <span :class="['pseudoBox', notTodayIsChecked && 'on']" @click='dontShowToday'></span> {{ $t('indexPage.noMoreTipToday') }}</div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      adVisible: false,
      notTodayIsChecked: false,
      isToday: "",
      adList: [],
      currentIndex: 0, //当前tab
      currentList: {} //当前列表
    };
  },
  mounted() {
    this.getGuideAd();
    console.log('hello');
  },
  methods: {
    // 今日不再显示逻辑
    dontShowToday(){
      this.notTodayIsChecked = !this.notTodayIsChecked
      if(this.notTodayIsChecked) {
        let currentDate = new Date().getDate().toString();
        localStorage.setItem('noLongerPrompted', 'true');
        localStorage.setItem('expirationDate', currentDate);
      } else {
        localStorage.removeItem('noLongerPrompted');
      }
    },
    getGuideAd() {
      // 需求为，只要设置今日不再弹出，那么不论有没有新的公告出来，当天都不再弹出，除非换浏览器，或者清缓存
      // 判断新的一天，判断时间，确认是否先清除时间标记
      let currentDate = new Date().getDate().toString();
      let storedDate = localStorage.getItem('expirationDate');
      if (storedDate && storedDate !== currentDate) {
        localStorage.removeItem('noLongerPrompted')
        localStorage.removeItem('oneTimeAd')
      };
      // 检查localStorage中是否存在今日不再提示的标记
      let isNoLongerPrompted = localStorage.getItem('noLongerPrompted') || null;
      if(isNoLongerPrompted) return
      
      this.$http.get(this.$api.getGuideAd).then((res) => {
        if (res && res.code == 0) {
          if (!res.data.length) return
          // 过滤掉后台设置不显示的 并且记录本次和缓存的是否有重叠
          let onetime = localStorage.getItem('oneTimeAd') || ''
          let tempArr = [], oneTimeAd = onetime.split('/')
          res.data = res.data.forEach(el => {
            // 拿到所以的数据id和弹窗方式，为了和缓存对比,如果同id数据的popUpRule变化了,需要移除缓存
            const result = oneTimeAd.filter(i => i.includes(el.id))
            if(result.length) {
              const rule = result[0].split(':')[1]
              if(rule !== el.popUpRule.toString()) {
                onetime = onetime.replace(`${el.id}:${rule}/`, '')
              }
            }
            if(el.popUpRule !== 0) tempArr.push(el)
          });
          // 过滤完的数据要记得再次缓存起来
          localStorage.setItem('oneTimeAd', onetime)
          // 过滤掉今日已经显示的
          if(onetime.length) tempArr = tempArr.filter(el => !onetime.includes(el.id))
          
          // 如果数据已经被过滤完，直接不走下面的逻辑
          if(!tempArr.length) return
          this.adList = tempArr;
          this.currentList = tempArr[0] || {};
          this.adVisible = true
          // 已经显示一次的（当天只显示一次的数据缓存）
          let s2 = ''
          // 开始缓存
          tempArr.forEach(el => {
            if(el.popUpRule === 1) s2 += `${el.id}:${el.popUpRule}/`
          })
          if(s2.length) localStorage.setItem('oneTimeAd', onetime + s2)
        }
      });
    },
    //弹出逻辑
    advertisingShow() {
      //弹出逻辑,popUpRule为0 1 2 分别对应弹出次数
      let self = this;
      let popUpRule = self.adList[0].popUpRule;
      if (popUpRule === 0) {
        //不弹
        return;
      } else if (popUpRule === 1) {
        //弹一次
        const JpOrAdv = sessionStorage.getItem("JpOrAdv");
        if (!JpOrAdv) {
          let t = localStorage.getItem("isToday");
          if (t) {
            //有时间
            let nowt = new Date().getTime();
            self.isToday = self.$common.isToday(t, nowt);
            if (!self.isToday) {
              self.adVisible = true;
              sessionStorage.setItem("JpOrAdv", true);
            }
          } else {
            //没时间
            self.adVisible = true;
            let timestamp = new Date().getTime();
            localStorage.setItem("isToday", timestamp);
            sessionStorage.setItem("JpOrAdv", true);
          }
        }
      } else if (popUpRule === 2) {
        //每次打开都弹
        const JpOrAdv = sessionStorage.getItem("JpOrAdv");
        if (!JpOrAdv) {
          self.adVisible = true;
          sessionStorage.setItem("JpOrAdv", true);
        }
      }
    },
    changeTab(item, index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;
      this.currentList = item;
    },
    closePop() {
      this.adVisible = false;
    },
    // banner图跳转
    bannerTransgo(item) {
      //1:外链 2:公告 3:活动 4:游戏 5:专题活动
      if (item.type === 1) {
        if (item.url) {
          window.open(item.url);
        }
      } else if (item.type === 2) {
        if (!this.$common.getUser()) {
          this.$message.warning(this.$t("enterGame.pleaseLogin"));
          return;
        }
        if (item.id) {
          this.$router.push("/my/service/notice");
          let items = {
            id: item.id
          };
          this.$store.commit("showSwiperNoticeDetail", items);
        }
      } else if (item.type === 3) {
        if (item.urlId) {
          // this.$sk.navigateTo ('/pages/actDetail/actDetail?actDeId='+item.urlId)
          this.$router.push({
            //从活动列表进入
            path: "/discount",
            query: {
              id: item.urlId
            }
          });
        }
      } else if (item.type === 4) {
        if (this.$common.getUser() && item.bannerGame.id) {
          this.getToken(item.bannerGame, 1);
        } else {
          this.$message.warning(this.$t("enterGame.pleaseLogin"));
        }
      } else if (item.type === 5) {
        if (item.expand && item.expand.actType == 3) {
          // 双旦活动
          this.jump11(item);
          return;
        }
        this.$http
          .get(
            this.$api.getThematicActivitiesByApp + "/" + item.urlId,
            "",
            true
          )
          .then(res => {
            if (res.code == 0) {
              this.$refs.refTimeDiscountDetail.pageData = res.data;
              this.$refs.refTimeDiscountDetail.dialogVisible = true;
            }
          });
      } else if (item.type === 7) {
        if (item.needLogin == 1 && !this.$common.getUser()) {
          this.$message.warning(this.$t("enterGame.pleaseLogin"));
          return;
        }
        this.$router.push({ path: item.url })
      }
    },
    // 跳转双11
    jump11(item) {
      if (!this.$common.getUser()) {
        this.$message.warning('请先登录！');
        return;
      }
      const obj = {
        activityId: item.urlId,
        token: this.$common.getToken(),
        clientCode: window.clientCode,
        username: this.$common.getUser().username,
        language: "zh_CN",
        theme: window.theme,
        host: this.$config.baseUrl,
      };
      const str = window.btoa(JSON.stringify(obj));
      // const url = item.expand.actUrl + "/pc/index.html?s=" + str;
      const url = window.location.origin + '/func/' + item.expand.actFolder + "/pc/index.html?s=" + str;
      window.open(url);
    },
    // 进入游戏
    getToken: async function (req, index) {
      // return
      let self = this;
      var issafariBrowser =
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent);

      if (!self.$common.getUser()) {
        // self.showLogin = true;
        self.$message.warning(self.$t("indexPage.pleaseLogin"));
        return;
      }
      self.tenantId = self.$common.getUser().tenant_id;
      self.username = self.$common.getUser().username;
      self.uid = self.$common.getUser().user_id;
      let datas = {
        tenantId: self.tenantId,
        username: self.username,
        gameId: index == 2 ? req.ids : req.id,
        clientIp: self.$config.clientIp,
        memberId: self.uid,
        terminalType: 1
      };
      self.$common.setGameRequestData(datas);

      const res = await self.$http.post(this.$api.getToken, datas, true);
      if (res.code == 0) {
        self.gameUrl = res.data;
        if (req.openMode === 1) {
          // if(issafariBrowser) {
          //  self.winOpen.location.href = self.gameUrl;
          // }else{
          window.open(self.gameUrl);
          // }
        } else {
          window.open(self.gameUrl);
        }
      } else {
        self.$message.error(self.$t('indexPage.repair'))
        // if (req.openMode === 1) {
        //     window.open("/error.html?type=1");
        //     // self.winOpen.location.href = '/error.html?type=1';
        // }

        // if (req.status === 0) {
        //     self.$message.error(self.$t("indexPage.repair"));
        // } else {
        //     self.$message.error(self.$t("indexPage.failed"));
        // }
      }
    },
  },
};
</script>
<style lang="scss">
.jackPotNew {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #f6daa7;
    border-radius: 5px;
  }

  div {
    box-sizing: border-box;
  }

  .el-dialog {
    background-color: transparent;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;

      .jkContent {
        display: flex;
        justify-content: space-between;
        width: 1070px;
        height: 497px;
        padding: 35px 22px 62px 35px;
        background: url('../../assets/images/amjs/jk_bg.png');

        .jkTabs {
          width: 338px;
          overflow: auto;

          li {
            cursor: pointer;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            width: 328px;
            height: 55px;
            margin-bottom: 15px;
            padding: 0 25px;
            background: url('../../assets/images/amjs/jk_tab.png') no-repeat;

            i {
              display: inline-block;
              width: 50px;
              height: 28px;
              margin-right: 6px;
              background: url('../../assets/images/amjs/jk_icon.png');
            }

            span {
              font-size: 22px;
              color: #bebebe;
              max-width: 221px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &.active {
              background: url('../../assets/images/amjs/jk_tab_active.png') no-repeat;

              i {
                background: url('../../assets/images/amjs/jk_icon_active.png');
              }

              span {
                color: #000;
              }
            }

            &:hover {
              opacity: .9;
            }
          }
        }

        .jkHtml {
          width: 658px;
          height: 396px;
          overflow: auto;
          border: solid 1px #4a4333;
          // background-color: #fff;
          border-radius: 7px;

          // padding: 10px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 7px;
            cursor: pointer;
          }
        }
      }

      .jkClose {
        cursor: pointer;
        width: 80px;
        height: 80px;
        margin: 15px auto 0;
        background: url('../../assets/images/amjs/jk_close.png') no-repeat;

        &:hover {
          opacity: .9;
        }
      }
    }
  }
  .notToday{
    display: flex;
    justify-content: center;
    color: #f4d8a5;
    align-items: center;
    .pseudoBox{
      width: 10px;
      height: 10px;
      display: flex;
      background: #fff;
      border: 1px solid #f4d8a5;
      margin-right: 10px;
      cursor: pointer;
      &.on{
        &::after {
          content: '✓';
          color: #000;
          transform: translate(1px, -4px);
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>